import { mqMin, space } from '@sunwebgroup/ui-components'
import { Icon, IconGlyph, Typography } from '@sunwebgroup/ui-components/uds/index'
import * as React from 'react'
import { PropsWithChildren } from 'react'
import { styled } from 'styled-components'

const SelectionTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  min-width: ${space('primitives_space_24')};

  ${Typography} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

`

const LongText = styled(Typography)`
  display: none;
  @media ${mqMin('primitives_breakpoint_m_min')} {
    display: block;
  }
`
const ShortText = styled(Typography)`
  display: block;
  @media ${mqMin('primitives_breakpoint_m_min')} {
    display: none;
  }
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${space('primitives_space_2')};
  overflow: hidden;
`

export function FilterSummary({ icon, texts }: PropsWithChildren<
  {
    icon: IconGlyph
    texts?: { long: string, short?: string }
  }
>) {
  if (!texts) {
    return null
  }

  return (
    <Wrapper>
      <Icon glyph={icon} size={16} />
      <SelectionTextWrapper>
        <LongText $variant="body-s-regular-tight">{texts.long}</LongText>
        <ShortText $variant="body-s-regular-tight">{texts.short || texts.long}</ShortText>
      </SelectionTextWrapper>
    </Wrapper>
  )
}
